import { CampaignFlatRateBlock, CampaignPackagesBlock, HtmlBlock } from '@/cms/definitions/content-types';
import BuyInsuranceSettings from '../BuyInsuranceSettings';
import { exception } from '@/appinsights/logging/ApplicationInsightLog';

export class HomeSettings extends BuyInsuranceSettings {
	public sumsLabel: string;
	public sumsSelectDefault: string;

	public constructor(settingsBlock: HtmlBlock, campaignBlocks: Array<CampaignFlatRateBlock | CampaignPackagesBlock>) {
		super(settingsBlock, campaignBlocks);
		this.loadHomeSettings();
	}

	/**
	 * load settings from CMS if present
	 */
	private loadHomeSettings() {
		try {
			let setting: string;
			const settingsArr = this.settingsBlock.markup.split('$');
			settingsArr.forEach((setting_) => {
				setting = setting_.toLowerCase().trim();
				if (setting.includes('___')) {
					// ignore setting
				} else if (setting.startsWith('sumslabel=')) {
					this.sumsLabel = this.getSettingsValue(setting_);
				} else if (setting.startsWith('sumsselectdefault=')) {
					this.sumsSelectDefault = this.getSettingsValue(setting_);
				}
			});
		} catch (e) {
			exception(e);
		}
	}
}
